export default __webpack_public_path__ + "static/media/3arrow.d0b4fbc5.svg";